import app from './feathers'
import { ircStore } from '../stores/ircStore'

const ircService = app.service('irc')

ircService.on('created', (data) => {
    methods.create(data)
})

const methods = {
    async create(data) {
        ircStore.add(data)
        return data
    },
    // async get() {
    //     ircStore.set(configs.data)
    //     return configs
    // },
    async remove(username) {
        ircStore.remove(username)
        return username
    },
}

export default methods
